import * as React from 'react';

import * as styles from './ErrorMessage.css';

export const ErrorMessage: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['error-message']}>{children}</div>
);

ErrorMessage.displayName = 'ErrorMessage';
